export default [
    {
        text: 'Bank statement',
    },
    {
        text: 'Utility bill',
    },
    {
        text: 'Rental agreement',
    },
    {
        text: 'Tax return',
    },
    {
        text: 'Tax bill',
    },
    {
        text: 'Any government issued\ndocument',
    },
    {
        text: 'Certificate of real estate\nownership',
    },
    {
        text: 'Certificate of residency',
    },
    {
        text: 'Mobile phone and home\ninternet bills',
        isRestricted: true,
    },
];
